import { Autocomplete, FormControl, TextField, Typography } from "@mui/material"
import theme from "css/theme/light"
import { FC } from "react"
import { StyledFormLabel } from "shared/styled/Global"
import { IFormSelectProps, IFormSelectValueProps } from "./formselect.interface"
import { useTranslation } from "react-i18next"

const FormSelect: FC<IFormSelectProps> = (props) => {
  const { id, labelKey, labelDefault, optional, options, handleChange, value, error, helperText } = props
  const { t } = useTranslation()

  return (
    <>
      <StyledFormLabel>
        <Typography variant="labelLarge" fontWeight={500}>
          {t(labelKey || "", { defaultValue: labelDefault })} {!optional && "*"}
        </Typography>
      </StyledFormLabel>
      <FormControl fullWidth>
        <Autocomplete
          {...props}
          sx={{ width: "100%", background: theme.palette.background.paper }}
          getOptionLabel={(option: IFormSelectValueProps) => t(option?.labelKey || "", { defaultValue: option?.label })}
          onChange={(e, option) => handleChange && handleChange(e, option?.value)}
          includeInputInList
          renderInput={(params) =>
            <TextField error={error}
              helperText={helperText}
              {...params} name={id?.toString()}
              variant="outlined" />}
        />
      </FormControl>
    </>
  )
}

export default FormSelect
